var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandscapeicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: 21,
    y: 33,
    width: 68,
    height: 43,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAAArCAYAAADBsS49AAACdUlEQVRogWIsKChIYGJi6mdgYBBgGNngwf///xsAAAAA//9iYmJiqh8NDDBQYGRknAAAAAD//2ICMQaBYwYHYGAQAAAAAP//YhrpIYACGBgYAAAAAP//YkEX6O3tHVgX0RkUFxcjbGRgYAAAAAD//xpNIciAgYEBAAAA//8aDRBkwMDAAAAAAP//Gg0QZMDAwAAAAAD//xoNEGTAwMAAAAAA//8aDRBkwMDAAAAAAP//Gg0QZMDAwAAAAAD//xoNEGTAwMAAAAAA//8aDRBkwMDAAAAAAP//Gg0QZMDAwAAAAAD//xoNEGTAwMAAAAAA//8aDRBkwMDAAAAAAP//Gg0QZMDAwAAAAAD//xoNEGTAwMAAAAAA//8aDRBkwMDAAAAAAP//Gg0QZMDAwAAAAAD//xoNEGTAwMAAAAAA//8aDRBkwMDAAAAAAP//Gg0QZMDAwAAAAAD//xoNEGTAwMAAAAAA//8aDRBkwMDAAAAAAP//Gg0QZMDAwAAAAAD//xoNEGTAwMAAAAAA//8aDRBkwMDAAAAAAP//Gg0QZMDAwAAAAAD//xoNEGTAwMAAAAAA//8aDRBkwMDAAAAAAP//Gg0QZMDAwAAAAAD//xoNEGTAwMAAAAAA//8aDRBkwMDAAAAAAP//Gg0QZMDAwAAAAAD//xoNEGTAwMAAAAAA//8aDRBkwMDAAAAAAP//Gg0QZMDAwAAAAAD//xoNEGTAwMAAAAAA//9iLCoq+j94nDPAgIGBAQAAAP//Gk0hyICBgQEAAAD//wIFyIfB45yBBf///38AAAAA//9i+vfvXyGIMZIDAgo+MDAwNAAAAAD//wMAeNgbWwnonccAAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscapeicon);
export default __webpack_public_path__ + "static/media/Landscape icon.61bac7e31f5f45ce931d9aab99526d9c.svg";
export { ForwardRef as ReactComponent };